import Vue from 'vue';
import { CombinedVueInstance } from 'vue/types/vue';
import _ from '../../utils';
import DialogConfirm from '../../components/p-dialog/p-dialog-confirm.vue';
import DialogPrompt from '../../components/p-dialog/p-dialog-prompt.vue';
import DialogNotify from '../../components/p-dialog/p-dialog-notify.vue';
import DialogConfirmDelete from '../../components/p-dialog/p-dialog-confirm-delete.vue';

export default class Dialog {
  private dialogStack = 0;

  mountDialog(dialogInstance: CombinedVueInstance<Vue, object, object, object, Record<never, any>>) {
    const root = _.component.getAppEl();
    const mountDiv = document.createElement('div');
    root!.insertBefore(mountDiv, null);
    dialogInstance.$on('destroyed', () => { this.dialogStack -= 1; });
    this.dialogStack += 1;
    const mounted = dialogInstance.$mount(mountDiv);
    const dialog = dialogInstance.$el as HTMLElement;
    const zIndex = this.dialogStack + 10000;
    dialog.style.zIndex = zIndex.toString();
    return mounted;
  }

  confirm(title: string, message: string, type: string = 'base'): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const dialog = this.mountDialog(new DialogConfirm({ propsData: { title, message, type } }));
      dialog!.$on('input', (value: boolean) => {
        resolve(value);
      });
    });
  }

  confirmDelete(entities: number | any[] = 1, type: string = 'warning'): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const dialog = this.mountDialog(new DialogConfirmDelete({ propsData: { entities, type } }));
      dialog!.$on('input', (value: boolean) => {
        resolve(value);
      });
    });
  }

  confirmDiscardChanges(type: string = 'warning'): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const title = Vue.$t('core.app.unsavedConfirmTitle');
      const message = Vue.$t('core.app.unsavedConfirmMessage');
      const dialog = this.mountDialog(new DialogConfirm({ propsData: { title, message, type } }));
      dialog!.$on('input', (value: boolean) => {
        resolve(value);
      });
    });
  }

  notify(title: string, message: string, type: string = 'info'): Promise<void> {
    return new Promise((resolve, reject) => {
      const dialog = this.mountDialog(new DialogNotify({ propsData: { title, message, type } }));
      dialog!.$on('input', (value: any) => {
        resolve(value);
      });
    });
  }

  prompt(title: string, message: string, defaultText?: string, type: string = 'base'): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const dialog = this.mountDialog(new DialogPrompt({
        propsData: {
          value: defaultText ?? '', title, message, type,
        },
      }));
      dialog!.$on('input', (value: string) => {
        resolve(value);
      });
    });
  }
}
